<template>
    <div>
        
        <!-- Filter Start -->
        <div class="innerBox mb-4">
            <div class="row">
                <!-- <a class="navbar-brand ml-3">Cek Nomor TO/NOPOL</a> -->
                <div class="col-md-9">
                    <input
                        class="form-control filterInput"
                        type="search"
                        placeholder="Masukkan Nomor TO/NOPOL"
                        aria-label="Search"
                        style="font: normal normal normal 16px/25px Poppins;"
                        v-model="filter.search"
                    >
                </div>
                <div class="col-md-3 text-right">
                    <button
                        class="btn"
                        type="button"
                        style="background-color: #1B698E; color: white; padding: 0 50px; height: 100%; font-weight: bold; font: normal normal 600 14px/21px Poppins;"
                        @click="updateData"
                    >CARI</button>
                </div>
            </div>
        </div>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox">
            <!-- Title & Option Buttons Start -->
            <div class="mb-4 row">
                <div class="col-md-3">
                    <!-- <button class="btn btn--mpm--transporter" @click="requestFullScreen">Full Screen</button> -->
                </div>
                <div class="col-md-4 text-center" style="display: flex; flex-direction: column-reverse;">
                    <h3 class="mb-0" style="font: normal normal normal 16px/25px Poppins;">Pengiriman Truck</h3>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                    <div class="d-flex">
                        <div class="col-4" style="display: flex; align-items: center;">
                            <span>Filter Tanggal</span>
                        </div>
                        <div class="col-8">
                            <flat-pickr
                                :config="rangePickr"
                                placeholder="Select Date"
                                v-model="selected.date"
                            ></flat-pickr>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Title & Option Buttons End -->

            <vue-universal-table
                api_url="/api/validation/pengiriman-truk"
                :filter="filter"
                :update="vue_universal_table.update"
                :fields="vue_universal_table.fields"
                :process_data="vue_universal_table.process_data"
                :buttons="vue_universal_table.buttons"
                :infinite_scroll="true"
                
                style_button="true"
                @onLihatRute="lihatRute"
            ></vue-universal-table>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <view-route
            v-if="modal.viewRoute"
            :propData="modal.viewRouteData"
            @closeModal="modal.viewRoute = false"
        ></view-route>
        <!-- Modal End -->
        
    </div>
</template>

<script>
    import moment from 'moment'
    import debounce from 'debounce'

    import viewRoute from './children/viewRouteModal'

    export default {
        metaInfo : {
            title : 'Pengiriman'
        },
        data () {
            let startDate = moment().subtract(7, 'days').format("YYYY-MM-DD");
            let currentDate = moment().format("YYYY-MM-DD");

            return {
                modal : {
                    viewRoute : false,
                    viewRouteData : null
                },
                rangePickr: {
                    mode: 'range',
                    dateFormat: "Y-m-d",
                    altInput: true,
                    altFormat: "d-m-Y",
                    altInputClass: 'form-control input mpm--transporter--flatpickr'
                },
                selected : {
                    date : `${startDate} to ${currentDate}`
                },
                filter : {
                    start : startDate,
                    end : currentDate,
                    search : null,
                },

                vue_universal_table : {
                    fields : [
                        {title:"NO TO", variable:"no_to"},
                        {title:"Dealer", variable:"dealer"},
                        {title:"SJ Total", variable:"sj"},
                        {title:"Koli Total", variable:"coly"},
                        {title:"Tanggal TO", variable:"tanggal_dokumen", date_format:"DD MMM YYYY"},
                        {title:"Ekspedisi", variable:"ekspedisi"},
                        {title:"NOPOL", variable:"nopol"},
                        {title:"Driver", variable:"driver"},
                        {title:"Kode Rute", variable:"kode_rute"},
                    ],
                    update: 0,
                    buttons : [
                        {title:'lihatRute', class:"fas fa-eye"},
                    ],
                    process_data : `
                        for (var i in data) {
                            data[i].dealer = data[i].jumlah_dealer_terkirim + "/" + data[i].jumlah_dealer
                            data[i].sj = data[i].driver_sj + "/" + data[i].total_sl
                            data[i].coly = data[i].driver_coly + "/" + data[i].total_coly
                            data[i].driver = data[i].driver.replace(/[^a-zA-Z0-9]/g, " ")
                        }
                    `
                }
            }
        },
        components : {
            viewRoute
        },
        watch : {
            'selected.date' () {
                let split = this.selected.date.split(" to ");
                this.filter.start = split[0];
                this.filter.end = split.length > 1 ? split[1] : split[0];
                
                this.updateDebounceData();
            },
        },
        mounted () {

        },
        methods : {
            updateData () {
                this.vue_universal_table.update++
            },
            updateDebounceData: debounce(function () {
                this.vue_universal_table.update++
            }, 1500),
            lihatRute (a) {
                this.modal.viewRouteData = JSON.parse(a);
                this.modal.viewRoute = true;
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;

    }

    .chart {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
        align-items: center;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .tableTitle {
        text-align: center;
    }
    
    /* .center {
        padding: 50px 20px;
        display: flexbox;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    } */

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .table td, .table th{
        text-align: center;
    }
</style>